import { render, staticRenderFns } from "./CircularProgressBar.vue?vue&type=template&id=03973e53&scoped=true&"
import script from "./CircularProgressBar.vue?vue&type=script&lang=js&"
export * from "./CircularProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03973e53",
  null
  
)

export default component.exports